module.exports = __webpack_public_path__ + "img/bg_architecture.289af6ff.png";